module.exports = __webpack_public_path__ + "img/lens-160-plus-07.743c44cb.png";